<template>
  <v-dialog
    content-class="elevation-0"
    persistent
    v-model="loading"
    width="500"
  >
    <v-container class="pa-15">
      <v-layout justify-center>
        <v-progress-circular
          color="light-blue"
          indeterminate
          size="200"
          width="20"
        />
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  props: {
    loading: {
      require: true,
      default: false,
      type: Boolean
    }
  },
}
</script>